import api from './api';

export interface WsfeTipCompDto {
    nroTipoFormulario: string;
    letra: string;
    codAfip: string;
    codAfip2: string;
}

const wsfeTipCompService = {
    getAll: async (searchTerm?: string): Promise<WsfeTipCompDto[]> => {
        const response = await api.get<WsfeTipCompDto[]>('/api/WsfeTipComp', {
            params: searchTerm?.trim() ? { searchTerm: searchTerm.trim() } : undefined,
        });
        return Array.isArray(response.data) ? response.data : [];
    },

    get: async (nroTipoFormulario: string, letra: string): Promise<WsfeTipCompDto> => {
        const response = await api.get<WsfeTipCompDto>(
            `/api/WsfeTipComp/${encodeURIComponent(nroTipoFormulario)}/${encodeURIComponent(letra)}`
        );
        return response.data;
    },

    create: async (dto: WsfeTipCompDto): Promise<WsfeTipCompDto> => {
        const response = await api.post<WsfeTipCompDto>('/api/WsfeTipComp', dto);
        return response.data;
    },

    update: async (nroTipoFormulario: string, letra: string, dto: WsfeTipCompDto): Promise<void> => {
        await api.put(
            `/api/WsfeTipComp/${encodeURIComponent(nroTipoFormulario)}/${encodeURIComponent(letra)}`,
            dto
        );
    },

    delete: async (nroTipoFormulario: string, letra: string): Promise<void> => {
        await api.delete(
            `/api/WsfeTipComp/${encodeURIComponent(nroTipoFormulario)}/${encodeURIComponent(letra)}`
        );
    },
};

export default wsfeTipCompService;
